/** @format */

import {Drawer, DrawerHeader} from '@sttark/design-system';
import React, {useState} from 'react';

export const ProofingInstructionsDrawer = () => {
    const [showDrawer, setShowDrawer] = useState(false);

    return (
        <>
            <div className="d-flex align-items-center justify-content-start">
                <i className="fa fa-circle-info color-accent-primary" />
                <button
                    className="me-0 my-0 ms-2 color-accent-primary"
                    onClick={() => setShowDrawer(true)}>
                    What to look for when reviewing proofs
                </button>
            </div>

            <Drawer onClose={() => setShowDrawer(false)} isOpen={showDrawer}>
                <DrawerHeader onCancel={() => setShowDrawer(false)} title={'Approving A Proof'} />
                <div>
                    <ul style={{listStyleType: 'disc', marginLeft: '20px'}}>
                        <li style={{listStyleType: 'disc', marginLeft: '20px'}}>
                            Your proof shows the final layout and content of your design. The image
                            quality on the electronic proof does not represent the final product.{' '}
                        </li>
                        <li style={{listStyleType: 'disc', marginLeft: '20px'}}>
                            To check the final size and layout of your labels, print this proof at
                            100% size with no scaling on your personal printer.{' '}
                        </li>
                        <li style={{listStyleType: 'disc', marginLeft: '20px'}}>
                            Your electronic proof does not reflect the color of your final print.
                            The colors shown will vary depending on the screen you are viewing your
                            proof.{' '}
                        </li>
                        <li style={{listStyleType: 'disc', marginLeft: '20px'}}>
                            If you are concerned about your final colors or image quality, please
                            contact us about ordering a Pantone match or a printed proof.{' '}
                        </li>
                    </ul>
                </div>
            </Drawer>
        </>
    );
};
